import { WppAccordion, WppButton, WppLabel, WppTypography } from '@wppopen/components-library-react'
import styles from './ManualUpload.module.scss'
import modalStyles from '../Modal.module.scss'
import { pluralise } from 'utils'

interface WarningsViewProps {
  warnings: string[]
  onSuccessCb: () => void
}

const WarningsView = ({ warnings, onSuccessCb }: WarningsViewProps) => {
  const handleSubmit = () => {
    onSuccessCb()
  }
  return (
    <>
      <div slot="body" className={styles.modal__body}>
        <WppTypography tag="p" type="s-body" data-testid="modal-disclaimer" className={styles.modal__disclaimer}>
          Your file has uploaded but there were{' '}
          <WppTypography tag="span" type="s-strong">
            {warnings.length}
          </WppTypography>{' '}
          {pluralise('task', warnings.length)} that could not be updated as they have not yet been generated.
        </WppTypography>

        <WppAccordion withDivider={false} size="s" className={styles.accordianContainer}>
          <WppLabel
            slot="header"
            htmlFor="name"
            typography="s-strong"
            optional={false}
            config={{
              text: 'View omitted tasks',
            }}
          />
          <ul className={styles.accordion__listContainer}>
            {warnings?.map((warning, idx) => (
              <li key={idx}>
                <WppTypography type="s-body">{warning}</WppTypography>
              </li>
            ))}
          </ul>
        </WppAccordion>
      </div>
      <div slot="actions" className={modalStyles.modal__actionsGroup}>
        <WppButton type="submit" variant="primary" data-testid="submit-modal" onClick={handleSubmit}>
          Ok
        </WppButton>
      </div>
    </>
  )
}

export default WarningsView
